
import { defineComponent, PropType } from '@vue/composition-api';

type SectionBg = 'white' | 'black' | 'gray' | 'surface' | 'transparent' | 'grey-600';
type SectionPadding = 'default' | 'large' | 'small' | 'none';

export default defineComponent({
  name: 'Section',
  props: {
    bgColor: {
      type: String as PropType<SectionBg>,
      default: 'surface',
    },
    paddingSize: {
      type: String as PropType<SectionPadding>,
      default: 'default',
    },
    containerSize: {
      type: String,
      default: 'fc-container-lg',
      validator: (value: string) => ['fc-container-sm', 'fc-container', 'fc-container-lg', 'fc-container-xl', 'none'].includes(value),
    },
    noContainer: {
      type: Boolean,
      default: false,
    },
  },
});
